<i class="fa fa-trash pointer" (click)="onSelect()"></i>

<app-question-modal [text]="documentName" (responseChanged)="handleResponse($event)" *ngIf="isModalOpen"></app-question-modal>
